module.exports = __webpack_public_path__ + "static/media/secao-1-500-bg_.076ab457.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/secao-1-500-bg_.jpg
// module id = 911
// module chunks = 5